import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';

import { actions as basketActions } from 'src/redux/basket/slice';
import {
  getBasketForEditing,
  getBasketForViewing,
  populateOptionValuesFromBasketItem,
} from 'src/redux/basket/thunks';

export const useEditProductOptions = () => {
  const dispatch = useDispatch();
  const { query } = useRouter();

  const retrieveEditItem = async () => {
    dispatch(basketActions.updateEditedItem(query.editItem as string));
    await dispatch(getBasketForEditing());
    await dispatch(populateOptionValuesFromBasketItem());
    dispatch(basketActions.setOptionsExpanded({ expanded: true }));
  };

  useEffect(() => {
    if (query.editItem) {
      retrieveEditItem();
    } else {
      dispatch(getBasketForViewing());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.editItem]);
};
